import * as React from "react";
import {  TextInput, SelectInput, NumberInput, DateTimeInput, required } from "react-admin";
import { Grid } from "@mui/material";
import {
  NotificationTypeEnum,
  StatusEnum,
} from "../../common/enum";
import Transformer from "../../common/Transformer";
import { NotificationEditComponent } from "./NotificationComponent";
import { Edit, SimpleForm} from "src/enterprise/ra-rbac";
import { FileInput } from "src/components/file-input";

export const NotificationEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {
        fromDate:
          typeof data["from_date"] === "string" ||
          typeof data["from_date"] === "undefined"
            ? data["from_date"]
            : (data["from_date"] as Date).toISOString(),
        toDate:
          typeof data["to_date"] === "string" ||
          typeof data["to_date"] === "undefined"
            ? data["to_date"]
            : (data["to_date"] as Date).toISOString(),
      },
    });
    return data;
  };

  return (
    <Edit
      component={NotificationEditComponent}
      mutationMode="pessimistic"
      transform={transform}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid container item rowSpacing={1} columnSpacing={2}>
            <Grid item sm={12} md={6}>
              <TextInput disabled source="id" />
            </Grid>
            <Grid item sm={12} md={6}>
              <DateTimeInput disabled source="created_at"/>
            </Grid>
          </Grid>
          <Grid item sm={12} md={6}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} md={6}>
            <SelectInput validate={required()} source="status" choices={StatusEnum} />
          </Grid>
          <Grid item sm={12} md={4}>
            <SelectInput
              validate={required()}
              source="type"
              choices={NotificationTypeEnum}
            />
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="from_date"/>
          </Grid>
          <Grid item sm={12} md={4}>
            <DateTimeInput validate={required()} source="to_date"/>
          </Grid>
          <Grid item sm={12} md={6}>
            <FileInput
              source="image"
              label="Image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP"]}
              multiple={false}
              required
              validate={required()}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <FileInput
              source="mobile_image"
              label="Mobile Image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP"]}
              multiple={false}
            /> 
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
